import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getCoach,
  getCoachDropdown,
  postAssignPlayerCoach,
} from "../../services/academicService";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";

const AssignCoachModal = ({ show, onClose, userData, onPaymentSuccess }) => {
  const [coachData, setCoachData] = useState([]);
  const [selectedCoach, setSelectedCoach] = useState(null);
  const [formData, setFormData] = useState({
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!selectedCoach) {
      toast.error("Please select a coach");
      return;
    }

    const payload = {
      playerId: userData?.id,
      coachIds: [selectedCoach?.value],
      description: formData.description,
    };

    // call your API here
    const res = await postAssignPlayerCoach(payload);
    if (res) {
      toast.success("Coach Assigned successfully");
      onPaymentSuccess(); // Refresh user data after payment
      resetForm(); // Reset form
    }
  };

  async function fetchCoach() {
    try {
      const res = await getCoach();
      console.log("Coach Data:", res);
      setCoachData(res?.content);
    } catch (error) {
      console.error("Error fetching coaches:", error);
    }
  }

  const loadCoachOptions = async (search, loadedOptions, { page }) => {
    const res = await getCoachDropdown({
      page, // number
      size: 10,
      search,
    });

    return {
      options: res.content.map((coach) => ({
        value: coach.id,
        label: coach.name,
      })),
      hasMore: !res.last,
      additional: {
        page: page + 1, // MUST be number
      },
    };
  };

  const resetForm = () => {
    setSelectedCoach(null);
    setFormData({
      description: "",
    });
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Assign Coach</Modal.Title>
      </Modal.Header>

      <Modal.Body size="l">
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label className="form-label">
                Coach<span className="text-danger">*</span>
              </label>
              <AsyncPaginate
                value={selectedCoach}
                loadOptions={loadCoachOptions}
                onChange={setSelectedCoach}
                placeholder="Search Coach"
                additional={{
                  page: 0,
                }}
              />
            </div>
          </div>

          <div className="col-sm-12 mb-3">
            <label className="form-label">Description</label>
            <input
              type="text"
              name="description"
              className="form-control"
              placeholder="Enter description"
              value={formData.description}
              onChange={handleChange}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            resetForm();
            onClose();
          }}
        >
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignCoachModal;
